/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { TrustedHostProfile } from 'object-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { TrustedHostProfileItem } from 'items/trusted-host-profile.item.factory';

/**
 * @description Trusted Host Profile Collection.
 * @author Manideep Kotha
 */
export class TrustedHostProfileCollection extends Collection {
    public static ngDependencies = [TrustedHostProfileItem];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'trustedhostprofile',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_SYSTEMCONFIGURATION,
            objectType: TrustedHostProfile,
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getNgDependency(TrustedHostProfileItem);
    }
}

export type TTrustedHostProfileCollection = typeof TrustedHostProfileCollection;
